// Centralised query-key factory so invalidation stays consistent across the app.
export const qk = {
  /** `GET /stats` — the analytics rollup behind the dashboard. */
  stats: (params) => ['stats', params ?? null],
  /** `GET /costs` — token spend (and render work, priced separately). Optionally one chapter. */
  costs: {
    root: ['costs'],
    totals: (params) => ['costs', 'totals', params ?? null],
    chapters: ['costs', 'chapters'],
  },
  /** `GET /plugins/library/books` — the shelf, grouped by class. */
  library: {
    books: (params) => ['library', 'books', params ?? null],
  },
  catalog: {
    root: ['catalog'],
    tree: (params) => ['catalog', 'tree', params],
    classes: ['catalog', 'classes'],
    subjects: (level) => ['catalog', 'classes', level, 'subjects'],
    chapters: (level, subject) => ['catalog', 'classes', level, subject, 'chapters'],
    subjectTree: (level, subject, params) => ['catalog', 'classes', level, subject, 'tree', params],
  },
  documents: {
    root: ['documents'],
    all: ['documents', 'all'], // eagerly-loaded full collection (client-side list)
    list: (params) => ['documents', 'list', params],
    detail: (id) => ['documents', 'detail', id],
    topics: (id, params) => ['documents', id, 'topics', params],
    paragraphs: (id, params) => ['documents', id, 'paragraphs', params],
    assets: (id, params) => ['documents', id, 'assets', params],
  },
  topics: {
    detail: (id) => ['topics', 'detail', id],
    paragraphs: (id, params) => ['topics', id, 'paragraphs', params],
    paragraphsAll: (id) => ['topics', id, 'paragraphs', 'all'], // every paragraph, pages merged
    assets: (id, params) => ['topics', id, 'assets', params],
  },
  paragraphs: {
    detail: (id) => ['paragraphs', 'detail', id],
    assets: (id, params) => ['paragraphs', id, 'assets', params],
  },
  assets: {
    detail: (id) => ['assets', 'detail', id],
  },
  system: {
    ping: ['system', 'ping'],
    healthz: ['system', 'healthz'],
    readyz: ['system', 'readyz'],
  },
};

export default qk;
